var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgGuidelineNoConsent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M27.55 17.413H16.558l.654-3.576a1.91 1.91 0 0 1 1.878-1.565h5.93c.921 0 1.711.658 1.877 1.565z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  fillRule: "evenodd",
  d: "M13.41 15.441a2.864 2.864 0 0 0-2.863 2.864v10.193a2.864 2.864 0 0 0 2.864 2.864h17.181a2.864 2.864 0 0 0 2.864-2.864V18.305a2.864 2.864 0 0 0-2.864-2.864zm5.415 7.603a3.34 3.34 0 1 1 6.681 0 3.34 3.34 0 0 1-6.681 0m3.34-4.773a4.773 4.773 0 1 0 0 9.545 4.773 4.773 0 0 0 0-9.545",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F87546",
  fillRule: "evenodd",
  d: "M1.479 22.001C1.479 10.667 10.667 1.479 22 1.479S42.524 10.667 42.524 22 33.335 42.524 22 42.524 1.479 33.335 1.479 22M22 5.297C12.775 5.297 5.297 12.775 5.297 22S12.775 38.705 22 38.705s16.704-7.478 16.704-16.704S31.227 5.297 22.001 5.297",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F87546",
  fillRule: "evenodd",
  d: "M10.228 34.724 32.204 7.531l3.34 2.7-21.976 27.193z",
  clipRule: "evenodd"
})));
export default SvgImgGuidelineNoConsent;